module.exports = __webpack_public_path__ + "static/media/sun.b1742f55.svg";